// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"831d7628","453":"8701dc61","918":"4092fd42"}[chunkId] + ".chunk.js";
};